<template>
  <section class="campaign">
    <Header :user="user" />
    <main class="main">
      <div class="row">
        <div class="col-md-12 mb-4">
          <Tabs
            :tabSelected="typelist"
            :tabs="tabs"
            @change="tabschanged($event)"
          />
        </div>
        <div class="col-md-4" v-if="![6, 7].includes(typelist)">
          <div class="card m-2 p-2 text-center">
            <h5>Emails</h5>
            <small>Emails Sent: {{ emails_sent }}</small>
            <small>Objetif: {{ total_emails }} emails</small>
            <div class="progress mb-4 border bg-secondary" style="height: 15px">
              <div
                class="progress-bar bg-primary pl-2"
                role="progressbar"
                :style="
                  'width:' +
                  getPercentageAvailable(emails_sent, total_emails) +
                  '%;'
                "
              >
                <small
                  >{{
                    getPercentageAvailable(emails_sent, total_emails)
                  }}%</small
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button @click="refresh()" class="btn btn-sm btn-primary">
                  <i class="icon-refresh"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" v-if="![6, 7].includes(typelist)">
          <div class="card m-2 p-2 text-center">
            <h5>Available contacts</h5>
            <small
              >Contacts found in last 10 minutes: {{ quantityTotal() }}</small
            >
            <small>Available: {{ available_contacts }}</small>
            <small>Objetif: {{ total }} contacts</small>
            <div class="progress mb-4 border bg-secondary" style="height: 15px">
              <div
                class="progress-bar bg-primary pl-2"
                role="progressbar"
                :style="
                  'width:' +
                  getPercentageAvailable(available_contacts, total) +
                  '%;'
                "
              >
                <small
                  >{{
                    getPercentageAvailable(available_contacts, total)
                  }}%</small
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button @click="refresh()" class="btn btn-sm btn-primary">
                  <i class="icon-refresh"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" v-if="![6, 7].includes(typelist)">
          <div class="card m-2 p-2 text-center">
            <h5>Total campaigns: {{ list.length }}</h5>
            <h5>Total targets: {{ totaltargets }}</h5>
            <h6>Api Keys</h6>
            <small>Total {{ apikeys.length }}</small>
            <small>Available: {{ available_apis }}</small>
            <small>Expired: {{ expired_api }}</small>
            <small
              >Total calls in last 10 minutes: {{ quantityCallsTotal() }}</small
            >
          </div>
        </div>
      </div>
      <div v-if="!loadingapi && typelist == 6" class="row">
        <div class="col-12 px-4">
          <button @click="refresh()" class="btn btn-sm btn-primary mb-1">
            <i class="icon-refresh"></i>
          </button>
          <div class="row">
            <div v-for="ak in apikeys" class="col-md-3 bg-light border">
              <div class="row px-3 pt-1">
                <small :class="ak.finished == 1 ? 'text-danger' : ''">{{
                  ak.api
                }}</small>
                <small
                  v-if="ak.api == 'iv4VBRKgGrtNBiDZjrmC-g'"
                  class="ml-2 text-secondary"
                  >plan 50/month - wencessz@gmail.com</small
                >
              </div>
              <div
                v-if="ak.finished == 0"
                class="progress border bg-secondary"
                style="height: 15px"
              >
                <div
                  class="progress-bar bg-primary pl-2 bg-success"
                  role="progressbar"
                  :style="
                    'width:' +
                    getPercentageAvailable(ak.calls, getTotalQuantityApi(ak)) +
                    '%;'
                  "
                ></div>
                <small class="text-white"
                  >{{
                    getPercentageAvailable(ak.calls, getTotalQuantityApi(ak))
                  }}%</small
                >
              </div>
              <div
                v-if="ak.finished == 1"
                class="progress border bg-secondary"
                style="height: 15px"
              >
                <div
                  class="progress-bar pl-2 bg-danger"
                  role="progressbar"
                  :style="'width:100%;'"
                ></div>
                <small class="text-white">100%</small>
              </div>
              <small v-if="ak.finished == 0" class="ml-1"
                >Total calls: {{ ak.calls }} of
                {{ getTotalQuantityApi(ak) }}</small
              >
              <small class="ml-2 float-right"
                >Last call: {{ ak.updated }}</small
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading && ![6, 7].includes(typelist)" class="row p-4">
        <div class="col-12" v-if="typelist == 2">
          <button
            @click="selectSentProblems()"
            v-if="!calculating && countselected == 0"
            class="btn btn-small btn-outline-primary"
          >
            Select only sent problems
          </button>
          <button
            @click="unselectAll()"
            v-if="!calculating && countselected > 0"
            class="btn btn-small btn-outline-primary"
          >
            Unselect all
          </button>
        </div>
        <div class="col-12" v-if="typelist == 1 || typelist == 2">
          <span v-if="countselected > 0 && processedcount < countselected">
            Calculate available ({{ countselected }})
            <button
              @click="calculateAll()"
              v-if="!calculating"
              class="btn btn-small btn-primary"
            >
              Start
            </button>
          </span>
          <div
            v-if="countselected > 0"
            class="progress mb-2 border bg-secondary"
            style="height: 15px"
          >
            <div
              class="progress-bar bg-primary pl-2 bg-success"
              role="progressbar"
              :style="
                'width:' +
                getPercentageAvailable(processedcount, countselected) +
                '%;'
              "
            ></div>
            <small class="text-white"
              >{{
                getPercentageAvailable(processedcount, countselected)
              }}%</small
            >
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-6 col-xl-4"
            v-if="
              listtarget.length > 0 &&
              listtarget[0].apollo_actual_page !== undefined
            "
            v-for="listtarget in resulttarget"
          >
            <div class="row my-2 card mx-1 py-3">
              <div class="col-12">
                <h6 class="mb-2">
                  {{ listtarget[0].target_name }} (id:
                  {{ listtarget[0].target_id }})
                </h6>
                <button
                  @click="getContactUsed(listtarget[0].target_id)"
                  class="btn btn-sm btn-primary"
                >
                  calculate
                </button>
              </div>
              <div class="col-md-12">
                <strong
                  >Target Total:
                  {{ parseInt(listtarget[0].apollo_total_contacts) }}
                  <small v-if="getPercentage(listtarget[0]) == 100">
                    <i class="icon-warning"></i> Target finished
                  </small>
                </strong>
                <div
                  class="progress border bg-secondary"
                  :style="
                    contactUsed[listtarget[0].target_id] != null &&
                    contactUsed[listtarget[0].target_id].used_target != null
                      ? 'height: 60px'
                      : 'height: 30px'
                  "
                >
                  <div
                    class="progress-bar pt-2"
                    :class="getColor(listtarget[0])"
                    role="progressbar"
                    :style="'width:' + getPercentage(listtarget[0]) + '%;'"
                  >
                    <small>
                      Processed:
                      {{
                        parseInt(listtarget[0].apollo_actual_page) * 10 >
                        parseInt(listtarget[0].apollo_total_contacts)
                          ? parseInt(listtarget[0].apollo_total_contacts)
                          : parseInt(listtarget[0].apollo_actual_page) * 10
                      }}
                      ({{ getPercentage(listtarget[0]) }}%)
                    </small>
                    <div
                      class="progress-bar bg-primary pl-2 pb-1"
                      role="progressbar"
                      :style="
                        'width:' + getPercentageImported(listtarget[0]) + '%;'
                      "
                    >
                      <small>
                        Imported: {{ listtarget[0].imported }} ({{
                          getPercentageImported(listtarget[0])
                        }}%)
                      </small>
                    </div>
                    <div
                      class="progress-bar bg-primary d-block"
                      role="progressbar"
                      :style="
                        'width:' + getPercentageImported(listtarget[0]) + '%;'
                      "
                    >
                      <div
                        v-if="
                          contactUsed[listtarget[0].target_id] != null &&
                          contactUsed[listtarget[0].target_id].used_target !=
                            null
                        "
                        class="progress-bar float-left bg-success pb-1"
                        role="progressbar"
                        :style="
                          'width:' +
                          getPercentageAvailable(
                            contactUsed[listtarget[0].target_id].used_target,
                            listtarget[0].imported
                          ) +
                          '%;'
                        "
                      >
                        <small>
                          Used:
                          {{ contactUsed[listtarget[0].target_id].used_target }}
                          ({{
                            +getPercentageAvailable(
                              contactUsed[listtarget[0].target_id].used_target,
                              listtarget[0].imported
                            )
                          }}%)
                        </small>
                      </div>
                      <div
                        v-if="
                          contactUsed[listtarget[0].target_id] != null &&
                          contactUsed[listtarget[0].target_id].used_other !=
                            null
                        "
                        class="progress-bar bg-light text-secondary pb-1"
                        role="progressbar"
                        :style="
                          'width:' +
                          getPercentageAvailable(
                            contactUsed[listtarget[0].target_id].used_other,
                            listtarget[0].imported
                          ) +
                          '%;'
                        "
                      >
                        <small>
                          Used Outside:
                          {{ contactUsed[listtarget[0].target_id].used_other }}
                          ({{
                            +getPercentageAvailable(
                              contactUsed[listtarget[0].target_id].used_other,
                              listtarget[0].imported
                            )
                          }}%)
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <small
                  class="text-danger text-left"
                  v-if="listtarget[0].finished == 1"
                >
                  <i class="icon-warning"></i>
                  {{ listtarget[0].api }} The maximum number of api calls
                  allowed for this end point is 300 times per day. ({{
                    listtarget[0].updated
                  }})<br />
                </small>
                <small
                  class="text-primary text-left"
                  v-if="listtarget[0].quantity > 0"
                >
                  <i class="icon-download"></i> Contacts obtained in Target last
                  10 minutes: {{ listtarget[0].quantity }} at:
                  {{ listtarget[0].created }}<br />
                </small>
                <small
                  class="text-primary text-left"
                  v-if="
                    listtarget[0].imported >
                    parseInt(listtarget[0].apollo_actual_page) * 10
                  "
                >
                  <i class="icon-warning"></i> if there are more contacts
                  imported than processed, it is because oliver start to import
                  again when the percentage of imports was too low.
                </small>
              </div>
              <div class="col-12 mt-3">
                <h6>Related campaigns</h6>
              </div>
              <div class="col-12">
                <div class="row px-3">
                  <li
                    v-if="
                      getSelected(item.campaigns) ||
                      countselected == 0 ||
                      typelist != 2
                    "
                    v-for="item in listtarget"
                    :class="
                      getPercentage(item) == 100 || item.emails_per_day == 0
                        ? 'bg-secondary text-white'
                        : 'bg-light'
                    "
                    class="float-left text-center card p-2 col-md-6"
                  >
                    <span v-if="typelist == 1 || typelist == 2">
                      <i
                        @click="select(item.campaigns)"
                        v-if="!getSelected(item.campaigns)"
                        class="
                          icon-circle
                          border
                          text-white
                          float-left
                          cursor-pointer
                        "
                      ></i>
                      <i
                        @click="unselect(item.campaigns)"
                        v-if="getSelected(item.campaigns)"
                        class="
                          icon-checkmark
                          border
                          text-primary
                          float-left
                          cursor-pointer
                        "
                      ></i>
                    </span>
                    <small>{{ item.name }} ({{ item.campaigns }})</small>

                    <small
                      class="text-secondary bg-white border mt-2"
                      v-if="listtarget[0].finished == 0"
                    >
                      <small class="d-block">Api: {{ item.api }}</small>
                      <small class="d-block">Calls: {{ item.calls }}</small>
                      <small class="d-block"
                        >Contacts last 10 min: {{ item.quantity }}</small
                      >
                      <small class="d-block"
                        >Last call: {{ item.updated }}</small
                      >
                    </small>
                    <small class="mt-4"
                      >Emails sent (Emails per day:
                      {{ item.emails_per_day }})</small
                    >
                    <div
                      class="progress mb-2 border bg-secondary"
                      style="height: 15px"
                    >
                      <div
                        class="progress-bar bg-primary pl-2 bg-success"
                        role="progressbar"
                        :style="
                          'width:' +
                          getPercentageAvailable(
                            item.new_emails,
                            item.email_volume
                          ) +
                          '%;'
                        "
                      >
                        <small
                          >{{ item.new_emails }} ({{
                            getPercentageAvailable(
                              item.new_emails,
                              item.email_volume
                            )
                          }}%) of {{ item.email_volume }}</small
                        >
                      </div>
                    </div>
                    <small
                      >Available contacts
                      <i
                        @click="calculateAvailable(item.campaigns)"
                        class="
                          p-1
                          rounded-circle
                          bg-primary
                          text-white
                          icon-refresh
                          cursor-pointer
                        "
                      ></i
                    ></small>
                    <div
                      class="progress mb-4 border bg-secondary"
                      style="height: 15px"
                    >
                      <div
                        class="progress-bar bg-primary pl-2"
                        role="progressbar"
                        :style="
                          'width:' +
                          getPercentageAvailable(item.available_contacts, 100) +
                          '%;'
                        "
                      >
                        <small
                          >{{ item.available_contacts }} ({{
                            getPercentageAvailable(
                              item.available_contacts,
                              100
                            )
                          }}%)</small
                        >
                      </div>
                    </div>

                    <small
                      class="text-white text-left"
                      v-if="item.emails_per_day == 0"
                    >
                      <i class="icon-warning"></i>
                      Emails per day = 0.
                    </small>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loadingapi && typelist == 7" class="row">
        <div class="col-12">
          <div class="card p-4">
          <table class="table table-striped">
            <thead>
              <th>{{ $t("lang.label.order")}}</th>
              <th>{{ $t("lang.label.subject")}}</th>
              <th>{{ $t("lang.label.message")}}</th>
            </thead>
            <template v-for="item in targetMissinDataItems">
              <tr :key="item.id">
                <td>
                  <router-link target="_blank" class="text-primary"
                    :to="'/orders/' + item.id"
                    @mousedown.native="mousedown('/orders/' + item.id)"
                  >
                    {{ item.name }}
                  </router-link>
                  <div class="small">
                      Total queue {{ item.total }}
                  </div>
                </td>
                <td><span v-html="item.subject"></span></td>
                <td><span v-html="item.message"></span></td>
              </tr>
            </template>
          </table>
          </div>
        </div>
      </div>
      <LoadingSpinnerBar v-if="loading" />
      <LoadingSpinnerBar v-if="loadingapi" />
    </main>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import Tabs from "@/components/Common/Tabs.vue";
import { campaignsService, targetsService } from "@/_services";
import ToastNotifications from "@/components/ToastNotifications.vue";
import LoadingSpinnerBar from "@/components/LoadingSpinnerBar.vue";

export default {
  data() {
    return {
      contactUsed: [],
      resulttarget: [],
      totaltargets: 0,
      calculating: false,
      countselected: 0,
      processedcount: 0,
      loadingapi: false,
      quantity: [],
      quantitycalls: [],
      selected: [],
      tabs: [
        {
          id: 4,
          name: this.$t("lang.label.all"),
        },
        {
          id: 1,
          name: "Problems detected",
        },
        {
          id: 2,
          name: this.$t("lang.label.activecampaigns"),
        },
        {
          id: 3,
          name: "Target finished",
        },
        {
          id: 5,
          name: "0 Emails per day",
        },
        {
          id: 6,
          name: "Api Keys",
        },
        {
          id: 7,
          name: "Target missing data",
        },
      ],
      loading: false,
      typelist: 6,
      list: [],
      total: 0,
      available_contacts: 0,
      apikeys: [],
      available_apis: 0,
      expired_api: 0,
      emails_sent: 0,
      total_emails: 0,
      targetMissinDataItems: [],
    };
  },

  mounted() {},

  created() {
    if (this.typelist == 6) {
      this.getApiKeys();
    }
    if (this.typelist == 7) {
      this.getTargetMissingData();
    } else {
      this.getCampaignsProblems(this.typelist);
    }

    this.udpdateHeader("campaigns");
  },

  components: {
    LoadingSpinnerBar,
    Tabs,
  },

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    getTotalQuantityApi(ak) {
      if (ak.api == "iv4VBRKgGrtNBiDZjrmC-g") {
        return 1000;
      }
      return 300;
    },
    getClassCols(cant) {
      if (cant == 1) {
        return "col-md-3";
      }
      if (cant == 2) {
        return "col-md-6";
      }
      if (cant == 3) {
        return "col-md-9";
      }
      if (cant > 3) {
        return "col-md-12";
      }
    },
    getClassCols2(cant) {
      if (cant == 1) {
        return "col-md-12";
      }
      if (cant == 2) {
        return "col-md-6";
      }
      if (cant == 3) {
        return "col-md-4";
      }
      if (cant > 3) {
        return "col-md-3";
      }
    },
    calculateAvailable(campaign_id) {
      this.loading = true;
      campaignsService.calculateAvailableContacts(campaign_id).then((res) => {
        this.refresh();
      });
    },
    selectSentProblems() {
      this.list.forEach((res) => {
        if (res.new_emails == null) {
          res.new_emails = 0;
        }
        if (res.new_emails == 0) {
          this.select(res.campaigns);
        }
      });
    },
    quantityTotal() {
      let total;
      let totalt;
      total = 0;
      totalt = 0;
      this.quantity.forEach((res) => {
        total = parseInt(total) + parseInt(res);
        totalt++;
      });

      this.totaltargets = totalt;
      return total;
    },
    quantityCallsTotal() {
      let total;
      let totalt;
      total = 0;
      totalt = 0;
      this.quantitycalls.forEach((res) => {
        total = parseInt(total) + parseInt(res);
        totalt++;
      });

      this.totalcalls = totalt;
      return total;
    },
    calculateAll() {
      this.calculating = true;
      this.selected.forEach((r) => {
        if (r) {
          let campaign_id = r;
          this.selected[r] = false;
          campaignsService
            .calculateAvailableContacts(campaign_id)
            .then((res) => {
              this.calculateAll();
              this.processedcount++;
              if (this.processedcount >= this.countselected) {
                this.calculating = false;
                this.refresh();
              }
              return;
            });
        }
      });
    },
    calculateSelected() {
      this.countselected = 0;
      this.selected.forEach((r) => {
        if (r) {
          this.countselected++;
        }
      });
    },
    select(campaign_id) {
      this.selected[campaign_id] = campaign_id;
      this.calculateSelected();
      this.$forceUpdate();
    },
    unselect(campaign_id) {
      delete this.selected[campaign_id];
      this.calculateSelected();
      this.$forceUpdate();
    },
    unselectAll() {
      this.selected = [];
      this.countselected = 0;
    },
    getSelected(campaign_id) {
      return this.selected[campaign_id];
    },
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
    tabschanged(id) {
      this.typelist = id;
      this.refresh();
    },
    refresh() {
      if (![6, 7].includes(this.typelist)) {
        (this.resulttarget = []), (this.totaltargets = 0), (this.quantity = []);
        this.quantitycalls = [];
        (this.countselected = 0),
          (this.processedcount = 0),
          (this.selected = []),
          (this.list = []),
          (this.total = 0),
          (this.available_contacts = 0),
          (this.apikeys = []),
          (this.available_apis = 0),
          (this.expired_api = 0),
          (this.emails_sent = 0),
          (this.total_emails = 0);
        this.getCampaignsProblems(this.typelist);
        this.getApiKeys();
      }
      if (this.typelist == 7) {
        this.getTargetMissingData();
      } else {
        this.getApiKeys();
      }
    },
    getContactUsed(target_id) {
      targetsService.getContactUsed(target_id).then((result) => {
        this.contactUsed[target_id] = result;
        this.$forceUpdate();
      });
    },
    getPercentageAvailable(available, total) {
      if (available == null) {
        available = 0;
      }
      if (total == null) {
        total = 0;
      }
      if (available == 0 && total == 0) {
        return 0;
      }
      return Math.round((available * 100) / total);
    },
    getPercentageImported(target) {
      let total = 0;
      if (
        parseInt(target.apollo_actual_page) * 10 >
        parseInt(target.apollo_total_contacts)
      ) {
        total = parseInt(target.apollo_total_contacts);
      } else {
        total = parseInt(target.apollo_actual_page) * 10;
      }
      if (total == 0 || target.imported == null) {
        return 0;
      }
      return Math.round((parseInt(target.imported) * 100) / total);
    },
    getPercentage(target) {
      let total = 0;
      if (
        parseInt(target.apollo_actual_page) * 10 >
        parseInt(target.apollo_total_contacts)
      ) {
        total = parseInt(target.apollo_total_contacts);
      } else {
        total = parseInt(target.apollo_actual_page) * 10;
      }
      if (total == 0 || target.apollo_total_contacts == null) {
        return 0;
      }
      return Math.round((total * 100) / parseInt(target.apollo_total_contacts));
    },

    getColor(target) {
      if (this.getPercentage(target) > 90) {
        return "bg-danger";
      }
      if (this.getPercentage(target) > 60) {
        return "bg-warning";
      }
      return "bg-success";
    },
    getCampaignsProblems(type) {
      this.loading = true;
      let actualtarget = 0;
      campaignsService.getCampaignsProblems(type).then((result) => {
        this.list = result;
        this.resulttarget = [];
        let targets = [];
        this.list.forEach((res) => {
          res.changetarget = false;
          if (res.target_id !== actualtarget) {
            res.changetarget = true;
            actualtarget = res.target_id;
            this.resulttarget.push(targets);
            targets = [];
          }
          targets.push(res);

          if (res.email_volume == null) {
            res.email_volume = 0;
          }
          if (res.emails_sent == null) {
            res.emails_sent = 0;
          }
          if (res.new_emails == null) {
            res.new_emails = 0;
          }
          if (res.available_contacts == null) {
            res.available_contacts = 0;
          }
          this.total_emails =
            parseInt(this.total_emails) + parseInt(res.email_volume);
          this.emails_sent =
            parseInt(this.emails_sent) + parseInt(res.new_emails);
          this.available_contacts =
            parseInt(this.available_contacts) +
            parseInt(res.available_contacts);
          this.total = parseInt(this.total) + parseInt(res.email_volume);
          this.loading = false;
          this.quantity[res.target_id] = res.quantity;
          this.quantitycalls[res.target_id] = res.calls;
        });
        this.resulttarget.push(targets);
      });
    },
    getApiKeys() {
      this.loadingapi = true;
      targetsService.getApiKeys().then((result) => {
        this.apikeys = result;
        this.apikeys.forEach((res) => {
          if (res.finished == 1) {
            this.expired_api++;
          } else {
            this.available_apis++;
          }
        });
        this.loadingapi = false;
      });
    },
    getTargetMissingData() {
      this.loadingapi = true;
      targetsService.getTargetMissingData().then((result) => {
        this.targetMissinDataItems = result;

        this.loadingapi = false;
      });
    },
  },
};
</script>